import { render, staticRenderFns } from "./requests.vue?vue&type=template&id=2dacfd74&scoped=true&lang=pug"
import script from "./requests.vue?vue&type=script&lang=js"
export * from "./requests.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dacfd74",
  null
  
)

/* custom blocks */
import block0 from "./requests.vue?vue&type=custom&index=0&blockType=router"
if (typeof block0 === 'function') block0(component)

export default component.exports